import { BACKGROUND_BILLING_EXCHANGE, BACKGROUND_COIN_EXCHANGE, BACKGROUND_GLOBAL_EXCHANGE, BACKGROUND_TRAD_EXCHANGE, BILLING_EXCHANGE, COIN_EXCHANGE, GLOBAL_EXCHANGE, TRAD_EXCHANGE } from "../../config/media";

const CARD_SECTIONS = [
    {
        image:GLOBAL_EXCHANGE,
        header:'Exchange hosting & domain', 
        description:'Access the hosting page to manage how your exchange server hosting and domain.',
        link:'Visit hosting page',
        linkPath:'/hosting',
        background:BACKGROUND_GLOBAL_EXCHANGE
    },
    {
        image:COIN_EXCHANGE,
        header:'Coins, tokens & digital assets', 
        description:'Add coins & fiat assets to your exchange. Check their verification status of newly added custom tokens.',
        link:'Visit assets page',
        linkPath:'/financial',
        background:BACKGROUND_COIN_EXCHANGE
    },
    {
        image:TRAD_EXCHANGE,
        header:'Trading pair markets', 
        description:'Pair up coins to create new trading pair markets. Select how your coins are priced, bought and sold.',
        link:'Visit markets page',
        linkPath:'/trade',
        background:BACKGROUND_TRAD_EXCHANGE
    },
    {
        image:BILLING_EXCHANGE,
        header:'Subscription billing', 
        description:'Pay for cloud subscriptions and exchange services. View and download invoices.',
        link:'Visit billing page',
        linkPath:'/billing',
        background:BACKGROUND_BILLING_EXCHANGE
    },
]

export default CARD_SECTIONS;